import { KnowledgeEntry } from 'shared/api/requests/aiAutomation/schemas'
import { KnowledgeEntry as KnowledgeEntryNew } from 'shared/api/requests/aiBusinessKnowledge/schemas'

export enum LoaderStatus {
  NOT_LOADED = 'NOT_LOADED',
  LOADED = 'LOADED',
  LOADING = 'LOADING',
}

export interface AiAutomationKnowledgeState {
  entries: KnowledgeEntry[] | KnowledgeEntryNew[]
  selectedEntryIndex: number | string | null
  loaderStatus: LoaderStatus
}
